//import { useRoute } from "vue-router";

//const route = useRoute();
export const SENDER = (Date.now() + Math.round(Math.random() * 100)).toString()
//export const SENDER = route.path
